import {createStore} from 'vuex'

import authentication from "@/store/authentication";
import personalData from "@/store/personalData";
import company from "@/store/company";
import cashRegister from "@/store/cashRegister";
import transaction from "@/store/transaction";
import good from "@/store/good";
import supplyAndWarehouseMove from "@/store/supplyAndWarehouseMove";
import staff from "@/store/staff";
import schedule from "@/store/schedule";
import payout from "@/store/payout";
import salaryReport from "@/store/salaryReport";
import task from "@/store/task";
import client from "@/store/client";
import promoCode from "@/store/promoCode";
import plan from "@/store/plan";
import csv from "@/store/csv";
import accrual from "@/store/accrual"
import statistics from "@/store/statistics"
import salesSearch from "@/store/salesSearch"
import salesSSE from "@/store/salesSSE"
import invoice from "@/store/invoice"
import appointment from "@/store/appointment"
import staffService from "@/store/staffService"
import goodCategory from "@/store/goodCategory"
import publicBooking from "@/store/publicBooking"
import appointmentsSSE from "@/store/appointmentsSSE"
import aiConcierge from "@/store/aiConcierge"


export default createStore({
    modules: {
        authentication,
        personalData,
        company,
        cashRegister,
        transaction,
        good,
        supplyAndWarehouseMove,
        staff,
        schedule,
        payout,
        accrual,
        salaryReport,
        task,
        client,
        promoCode,
        plan,
        csv,
        statistics,
        salesSearch,
        salesSSE,
        invoice,
        appointment,
        staffService,
        goodCategory,
        publicBooking,
        appointmentsSSE,
        aiConcierge,
    },
    state: {},
    mutations: {},
    actions: {},
})
